@media print {
  body * {
    visibility: hidden !important;
  }
  @page {
    size: A4 portrait !important;
    margin: 2cm;
  }
  #section-to-print, #section-to-print * {
    visibility: visible !important;
  }
  #section-to-print {
    width: 100% !important;
    height: 100% !important;
    position: absolute !important;
    left: 0 !important;
    top: 0 !important;
    border: none;
  }
}
